export function buildAuthEndpointUrl(serviceBase: string, serviceContext: string | undefined, path: string): string {
  const normalizedBase = (serviceBase || window.location.origin).replace(/\/$/, '');
  const normalizedContext = serviceContext
    ? serviceContext.startsWith('/') ? serviceContext : `/${serviceContext}`
    : '';

  return `${normalizedBase}${normalizedContext}/auth${path}`;
}
